'use client'
import DOMPurify from 'dompurify'
import Image from 'next/image'
import {ReactSVG} from 'react-svg'
import {notifyBugsnag} from '~/utils/Bugsnag/notify'
import {type LogoFragment} from './_generated/query.graphql'

const LogoMashItem = ({logo}: {logo: LogoFragment['logo']}) => {
  return (
    <ReactSVG
      beforeInjection={svg => {
        DOMPurify.sanitize(svg, {
          IN_PLACE: true,
          USE_PROFILES: {svg: true, svgFilters: true},
        })
      }}
      onError={error => {
        notifyBugsnag('Error injecting LogoMash svg', {
          caughtError: error,
        })
      }}
      src={logo.logo.url}
      title={logo.companyName}
      fallback={() => (
        <Image
          src={logo.logo.url}
          alt={logo.companyName}
          width={logo.logo.width}
          height={logo.logo.height}
          className="h-full w-auto"
        />
      )}
      wrapper="span"
    />
  )
}

export default LogoMashItem
